export const metadata = {
  createFabric: 'metadata.create.fabric',
  createFabricSuccess: 'fabric.entity.creation.successful',
  updateFabric: 'metadata.update.fabric',
  updateFabricSuccess: 'fabric.entity.updation.successful'
};
